import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d5a430e2")

_pushScopeId("data-v-d5a430e2")
const _hoisted_1 = { class: "InvoiceDocument" }
const _hoisted_2 = { class: "InvoiceDocument__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "header__logo",
  viewBox: "0 0 165 76",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M38.0879 57.6154C34.3215 57.6154 31.1597 56.8206 28.6027 55.2311C26.0802 53.6416 24.3007 51.4301 23.264 48.5966L31.1943 43.9836C32.5419 47.1972 34.9262 48.804 38.3471 48.804C41.1805 48.804 42.5973 47.9919 42.5973 46.3679C42.5973 45.3313 41.7852 44.4674 40.1612 43.7763C39.6083 43.569 38.0879 43.1025 35.6 42.3768C32.0754 41.3748 29.3974 39.9753 27.5661 38.1785C25.7347 36.3816 24.819 33.9974 24.819 31.0257C24.819 27.6739 26.0111 24.9614 28.3954 22.8881C30.8487 20.8148 33.855 19.7782 37.4141 19.7782C40.4549 19.7782 43.1501 20.5039 45.4998 21.9551C47.8495 23.3719 49.6464 25.4106 50.8903 28.0713L43.1156 32.6325C41.9753 29.9372 40.0921 28.5896 37.4659 28.5896C36.3947 28.5896 35.5654 28.8142 34.978 29.2634C34.3906 29.6781 34.0969 30.2482 34.0969 30.9739C34.0969 31.7686 34.5115 32.4424 35.3408 32.9953C36.2047 33.5482 37.8633 34.1874 40.3167 34.9131C42.148 35.4659 43.5648 35.9497 44.5669 36.3644C45.7072 36.8481 46.882 37.5047 48.0914 38.334C50.6139 39.9926 51.8751 42.636 51.8751 46.2642C51.8751 49.8233 50.6139 52.605 48.0914 54.6091C45.5689 56.6133 42.2344 57.6154 38.0879 57.6154ZM71.1027 30.1964C74.5581 30.1964 77.4434 31.5095 79.7586 34.1356C82.1083 36.7617 83.2831 40.0099 83.2831 43.88C83.2831 47.7501 82.1083 51.0155 79.7586 53.6762C77.4089 56.2677 74.5236 57.5635 71.1027 57.5635C67.9582 57.5635 65.5048 56.5269 63.7426 54.4536V67.2042H55.1385V30.922H63.7426V33.3063C65.5048 31.233 67.9582 30.1964 71.1027 30.1964ZM65.2457 47.9747C66.2478 49.0113 67.5608 49.5296 69.1849 49.5296C70.809 49.5296 72.122 49.0113 73.1241 47.9747C74.1262 46.9035 74.6272 45.5386 74.6272 43.88C74.6272 42.2213 74.1262 40.8564 73.1241 39.7853C72.122 38.7486 70.809 38.2303 69.1849 38.2303C67.5608 38.2303 66.2478 38.7486 65.2457 39.7853C64.2436 40.8564 63.7426 42.2213 63.7426 43.88C63.7426 45.5386 64.2436 46.9035 65.2457 47.9747ZM105.324 33.3063V30.922H113.928V56.8379H105.324V54.4536C103.561 56.5269 101.108 57.5635 97.9636 57.5635C94.4736 57.5635 91.5711 56.2677 89.2559 53.6762C86.9408 51.05 85.7832 47.7846 85.7832 43.88C85.7832 39.9408 86.9408 36.6926 89.2559 34.1356C91.5711 31.5095 94.4736 30.1964 97.9636 30.1964C101.108 30.1964 103.561 31.233 105.324 33.3063ZM95.9422 47.9747C96.9097 49.0113 98.2228 49.5296 99.8814 49.5296C101.54 49.5296 102.853 49.0113 103.821 47.9747C104.823 46.9035 105.324 45.5386 105.324 43.88C105.324 42.2213 104.823 40.8564 103.821 39.7853C102.853 38.7486 101.54 38.2303 99.8814 38.2303C98.2228 38.2303 96.9097 38.7486 95.9422 39.7853C94.9401 40.8564 94.4391 42.2213 94.4391 43.88C94.4391 45.5386 94.9401 46.9035 95.9422 47.9747ZM127.52 30.922V35.7424C128.004 34.0838 128.954 32.788 130.371 31.855C131.822 30.8875 133.463 30.4037 135.295 30.4037V39.9408C133.325 39.6298 131.528 39.9926 129.904 41.0292C128.315 42.0659 127.52 43.759 127.52 46.1087V56.8379H118.916V30.922H127.52ZM155.089 43.88L164.16 56.8379H154.519L147.159 45.7977V56.8379H138.555V20.5557H147.159V41.7549L153.846 30.922H163.797L155.089 43.88Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    width: "10.3307",
    height: "64.5668",
    fill: "#8BC514"
  })
], -1)
const _hoisted_4 = { class: "header__terminals" }
const _hoisted_5 = { class: "terminals__terminal" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "terminal__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жөнелту терминалы /"),
  /*#__PURE__*/_createVNode("span", null, "Терминал отправления")
], -1)
const _hoisted_7 = { class: "terminal__cells" }
const _hoisted_8 = { class: "cells__cell" }
const _hoisted_9 = { class: "cells__cell" }
const _hoisted_10 = { class: "cells__cell" }
const _hoisted_11 = { class: "terminals__terminal terminal--receive" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "terminal__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Қабылдау терминалы /"),
  /*#__PURE__*/_createVNode("span", null, "Терминал получения")
], -1)
const _hoisted_13 = { class: "terminal__cells" }
const _hoisted_14 = { class: "cells__cell" }
const _hoisted_15 = { class: "cells__cell" }
const _hoisted_16 = { class: "cells__cell" }
const _hoisted_17 = { class: "header__barcode" }
const _hoisted_18 = { class: "barcode__image" }
const _hoisted_19 = { class: "barcode__invoice-number" }
const _hoisted_20 = { class: "invoice-number__value" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "invoice-number__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүкқұжат нөмірі /"),
  /*#__PURE__*/_createVNode("span", null, "Номер накладной")
], -1)
const _hoisted_22 = { class: "header__numbers" }
const _hoisted_23 = { class: "numbers__order-number" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "order-number__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Тапсырыc нөмiрi /"),
  /*#__PURE__*/_createVNode("span", null, "Номер заказа")
], -1)
const _hoisted_25 = { class: "order-number__value" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_27 = { class: "numbers__customer-number" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "customer-number__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Тапсырыс берушiнiң жүк құжат нөмiрi /"),
  /*#__PURE__*/_createVNode("span", null, "Номер накладной заказчика")
], -1)
const _hoisted_29 = { class: "customer-number__value" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_31 = { class: "header__shipment-type" }
const _hoisted_32 = { class: "shipment-type__checkboxes" }
const _hoisted_33 = { class: "checkboxes__checkbox" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Стандарт", -1)
const _hoisted_35 = { class: "checkboxes__checkbox" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Опасный груз", -1)
const _hoisted_37 = { class: "checkboxes__checkbox" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Экспресс", -1)
const _hoisted_39 = { class: "checkboxes__checkbox" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Температурный режим", -1)
const _hoisted_41 = { class: "checkboxes__checkbox" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Проекты", -1)
const _hoisted_43 = { class: "checkboxes__input" }
const _hoisted_44 = { class: "checkboxes__checkbox" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Батарея", -1)
const _hoisted_46 = { class: "checkboxes__checkbox" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "checkbox__label" }, "Автозапчасти", -1)
const _hoisted_48 = { class: "InvoiceDocument__content" }
const _hoisted_49 = { class: "content__row" }
const _hoisted_50 = { class: "content__row" }
const _hoisted_51 = { class: "content__block template block--border-default" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жіберуші / Отправитель")
], -1)
const _hoisted_53 = { class: "content__value value--small" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_55 = { class: "content__block template block--border-default" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Алушы / Получатель")
], -1)
const _hoisted_57 = { class: "content__value value--small" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_59 = { class: "content__row" }
const _hoisted_60 = { class: "content__block template-address block--border-default" }
const _hoisted_61 = { class: "template-address__column" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Мекен-жайы / Адрес")
], -1)
const _hoisted_63 = { class: "content__value value--small" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_65 = { class: "template-address__column" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Сектор /"),
  /*#__PURE__*/_createVNode("span", null, "Сектор")
], -1)
const _hoisted_67 = { class: "content__value" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_69 = { class: "content__block template-address block--border-default" }
const _hoisted_70 = { class: "template-address__column" }
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Мекен-жайы / Адрес")
], -1)
const _hoisted_72 = { class: "content__value value--small" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_74 = { class: "template-address__column" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Сектор /"),
  /*#__PURE__*/_createVNode("span", null, "Сектор")
], -1)
const _hoisted_76 = { class: "content__value" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_78 = { class: "content__row" }
const _hoisted_79 = { class: "content__block template-building block--border-default" }
const _hoisted_80 = { class: "template-building__column" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Үй / Ғимарат"),
  /*#__PURE__*/_createVNode("span", null, "Дом / Здание")
], -1)
const _hoisted_82 = { class: "content__value" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_84 = { class: "template-building__column" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Пәтер / Кеңсе"),
  /*#__PURE__*/_createVNode("span", null, "Кв / Офис")
], -1)
const _hoisted_86 = { class: "content__value" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_88 = { class: "template-building__column" }
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Индекс /"),
  /*#__PURE__*/_createVNode("span", null, "Индекс")
], -1)
const _hoisted_90 = { class: "content__value" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" не указ. ")
const _hoisted_92 = { class: "content__block template-building block--border-default" }
const _hoisted_93 = { class: "template-building__column" }
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Үй / Ғимарат"),
  /*#__PURE__*/_createVNode("span", null, "Дом / Здание")
], -1)
const _hoisted_95 = { class: "content__value" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_97 = { class: "template-building__column" }
const _hoisted_98 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Пәтер / Кеңсе"),
  /*#__PURE__*/_createVNode("span", null, "Кв / Офис")
], -1)
const _hoisted_99 = { class: "content__value" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_101 = { class: "template-building__column" }
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Индекс /"),
  /*#__PURE__*/_createVNode("span", null, "Индекс")
], -1)
const _hoisted_103 = { class: "content__value" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" не указ. ")
const _hoisted_105 = { class: "content__row" }
const _hoisted_106 = { class: "content__block comment block--border-default" }
const _hoisted_107 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Пікір /"),
  /*#__PURE__*/_createVNode("span", null, "Комментарий")
], -1)
const _hoisted_108 = { class: "content__value value--small" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_110 = { class: "content__block comment block--border-default" }
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Пікір /"),
  /*#__PURE__*/_createVNode("span", null, "Комментарий")
], -1)
const _hoisted_112 = { class: "content__value value--small" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_114 = { class: "content__row" }
const _hoisted_115 = { class: "content__block contacts block--border-left block--border-right" }
const _hoisted_116 = { class: "contacts__column" }
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Байланыс телефоны /"),
  /*#__PURE__*/_createVNode("span", null, "Контактный телефон")
], -1)
const _hoisted_118 = { class: "content__value value--small" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_120 = { class: "contacts__column" }
const _hoisted_121 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Байланысатын тұлғасы /"),
  /*#__PURE__*/_createVNode("span", null, "Контактное лицо")
], -1)
const _hoisted_122 = { class: "content__value" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_124 = { class: "content__block contacts block--border-left block--border-right" }
const _hoisted_125 = { class: "contacts__column" }
const _hoisted_126 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Байланыс телефоны /"),
  /*#__PURE__*/_createVNode("span", null, "Контактный телефон")
], -1)
const _hoisted_127 = { class: "content__value value--small" }
const _hoisted_128 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_129 = { class: "contacts__column" }
const _hoisted_130 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Байланысатын тұлғасы /"),
  /*#__PURE__*/_createVNode("span", null, "Контактное лицо")
], -1)
const _hoisted_131 = { class: "content__value" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_133 = { class: "content__row" }
const _hoisted_134 = { class: "content__row" }
const _hoisted_135 = { class: "content__block parameters block--border-default" }
const _hoisted_136 = { class: "parameters__column" }
const _hoisted_137 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Орын саны /"),
  /*#__PURE__*/_createVNode("span", null, "Количество мест")
], -1)
const _hoisted_138 = { class: "content__value" }
const _hoisted_139 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_140 = { class: "parameters__column" }
const _hoisted_141 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүктiң салмағы (кг) /"),
  /*#__PURE__*/_createVNode("span", null, "Вес груза (кг)")
], -1)
const _hoisted_142 = { class: "content__value" }
const _hoisted_143 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_144 = { class: "parameters__column" }
const _hoisted_145 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Жүк көлемi (м"),
    /*#__PURE__*/_createVNode("sup", null, "3"),
    /*#__PURE__*/_createTextVNode(") /")
  ]),
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Объем груза (м"),
    /*#__PURE__*/_createVNode("sup", null, "3"),
    /*#__PURE__*/_createTextVNode(")")
  ])
], -1)
const _hoisted_146 = { class: "content__value" }
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_148 = { class: "content__block additional-checkboxes block--border-default" }
const _hoisted_149 = { class: "additional-checkboxes__column" }
const _hoisted_150 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүк тиеушілер /"),
  /*#__PURE__*/_createVNode("span", null, "Грузчики")
], -1)
const _hoisted_151 = { class: "additional-checkboxes__column" }
const _hoisted_152 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Рохля /"),
  /*#__PURE__*/_createVNode("span", null, "Рохля")
], -1)
const _hoisted_153 = { class: "additional-checkboxes__column" }
const _hoisted_154 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Кран /"),
  /*#__PURE__*/_createVNode("span", null, "Кран")
], -1)
const _hoisted_155 = { class: "content__row" }
const _hoisted_156 = { class: "content__block payments block--border-default" }
const _hoisted_157 = { class: "payments__column" }
const _hoisted_158 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Төленетiн құн /"),
  /*#__PURE__*/_createVNode("span", null, "Сумма к оплате")
], -1)
const _hoisted_159 = { class: "content__value" }
const _hoisted_160 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_161 = { class: "payments__column" }
const _hoisted_162 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Салынған төлем /"),
  /*#__PURE__*/_createVNode("span", null, "Наложенный платеж")
], -1)
const _hoisted_163 = { class: "content__value" }
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_165 = { class: "payments__column" }
const _hoisted_166 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жарияланған құн /"),
  /*#__PURE__*/_createVNode("span", null, "Объявленная стоимость")
], -1)
const _hoisted_167 = { class: "content__value" }
const _hoisted_168 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_169 = { class: "content__row" }
const _hoisted_170 = { class: "content__block types block--border-default" }
const _hoisted_171 = {
  key: 0,
  class: "types__column"
}
const _hoisted_172 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Төлем жөнелтуші /"),
  /*#__PURE__*/_createVNode("span", null, "Оплата отправителем")
], -1)
const _hoisted_173 = {
  key: 1,
  class: "types__column"
}
const _hoisted_174 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Үшінші тараптың төлемі /"),
  /*#__PURE__*/_createVNode("span", null, "Оплата третьим лицом")
], -1)
const _hoisted_175 = {
  key: 2,
  class: "types__column"
}
const _hoisted_176 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Қолма-қол ақшамен /"),
  /*#__PURE__*/_createVNode("span", null, "Наличными")
], -1)
const _hoisted_177 = {
  key: 3,
  class: "types__column"
}
const _hoisted_178 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Төлем алушы /"),
  /*#__PURE__*/_createVNode("span", null, "Оплата получателем")
], -1)
const _hoisted_179 = {
  key: 4,
  class: "types__column"
}
const _hoisted_180 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Kaspi.kz арқылы /"),
  /*#__PURE__*/_createVNode("span", null, "Оплата на kaspi.kz")
], -1)
const _hoisted_181 = { class: "types__column" }
const _hoisted_182 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Шот бойынша аудару /"),
  /*#__PURE__*/_createVNode("span", null, "Перечислением по счету")
], -1)
const _hoisted_183 = { class: "content__block template block--border-default" }
const _hoisted_184 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Алушы (Т.А.Ә) /"),
  /*#__PURE__*/_createVNode("span", null, "Получатель (Ф.И.О)")
], -1)
const _hoisted_185 = { class: "content__value value--small" }
const _hoisted_186 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_187 = { class: "content__row" }
const _hoisted_188 = { class: "content__block template block--border-default" }
const _hoisted_189 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүк атауы /"),
  /*#__PURE__*/_createVNode("span", null, "Наименование груза")
], -1)
const _hoisted_190 = { class: "content__value" }
const _hoisted_191 = /*#__PURE__*/_createVNode("div", { class: "content__block template block--border-default" }, [
  /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createVNode("span", null, "Алынған (орындар саны) /"),
    /*#__PURE__*/_createVNode("span", null, "Получено (количество мест)")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "content__value" })
], -1)
const _hoisted_192 = { class: "content__row" }
const _hoisted_193 = { class: "content__block additional-checkboxes block--border-default" }
const _hoisted_194 = { class: "additional-checkboxes__column" }
const _hoisted_195 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүк тиеушілер /"),
  /*#__PURE__*/_createVNode("span", null, "Грузчики")
], -1)
const _hoisted_196 = { class: "additional-checkboxes__column" }
const _hoisted_197 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Рохля /"),
  /*#__PURE__*/_createVNode("span", null, "Рохля")
], -1)
const _hoisted_198 = { class: "additional-checkboxes__column" }
const _hoisted_199 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Кран /"),
  /*#__PURE__*/_createVNode("span", null, "Кран")
], -1)
const _hoisted_200 = /*#__PURE__*/_createVNode("div", { class: "content__block template block--border-default" }, [
  /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createVNode("span", null, "Жеткізу бойынша ескертпе /"),
    /*#__PURE__*/_createVNode("span", null, "Примечания по доставке")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "content__value" })
], -1)
const _hoisted_201 = { class: "content__row" }
const _hoisted_202 = {
  class: "content__block",
  style: {"padding":"0"}
}
const _hoisted_203 = { class: "content__block additional-checkboxes block--border-left block--border-right" }
const _hoisted_204 = { class: "additional-checkboxes__column" }
const _hoisted_205 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жүк жәшігі /"),
  /*#__PURE__*/_createVNode("span", null, "Обрешетка")
], -1)
const _hoisted_206 = { class: "additional-checkboxes__column" }
const _hoisted_207 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жұмсақ орау /"),
  /*#__PURE__*/_createVNode("span", null, "Мягкая упаковка")
], -1)
const _hoisted_208 = { class: "additional-checkboxes__column" }
const _hoisted_209 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Паллетеу /"),
  /*#__PURE__*/_createVNode("span", null, "Паллетирование")
], -1)
const _hoisted_210 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block receiver-sign block--border-default\" data-v-d5a430e2><div class=\"receiver-sign__columns\" data-v-d5a430e2><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Қолы /</span><span data-v-d5a430e2>Подпись</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Күні /</span><span data-v-d5a430e2>Дата</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Уақыты /</span><span data-v-d5a430e2>Время</span></div><span class=\"content__value\" data-v-d5a430e2></span></div></div><p class=\"receiver-sign__hint\" data-v-d5a430e2> Жөнелтімді толық көлемде алғанымды, «Spark Логистика» ЖШС-не шағымдарым жоқ екенін өз қолыммен растаймын. / Своей подписью подтверждаю, что отправление получено в полном объеме, претензий к ТОО &quot;Spark Логистика&quot; не имею. </p></div>", 1)
const _hoisted_211 = { class: "content__row" }
const _hoisted_212 = { class: "content__block block--border-default note" }
const _hoisted_213 = { class: "note-block" }
const _hoisted_214 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Жіберу бойынша ескертпе /"),
  /*#__PURE__*/_createVNode("span", null, "Примечание по отправке")
], -1)
const _hoisted_215 = { class: "content__value" }
const _hoisted_216 = /*#__PURE__*/_createTextVNode(" не указано ")
const _hoisted_217 = /*#__PURE__*/_createVNode("div", {
  class: "note-block",
  style: {"min-width":"120px"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createVNode("span", null, "Орын саны /"),
    /*#__PURE__*/_createVNode("span", null, "Количество мест")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "content__value" })
], -1)
const _hoisted_218 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block courier-sign block--border-default\" data-v-d5a430e2><p class=\"courier-sign__hint\" data-v-d5a430e2> Курьермен толтырылады. Барлық жолдарды толтыру міндетті/ Заполняется Курьером. Все поля обязательны к заполнению </p><div class=\"courier-sign__columns\" data-v-d5a430e2><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Жеткiзушi курьер /</span><span data-v-d5a430e2>Курьер доставки</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Күні /</span><span data-v-d5a430e2>Дата</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Уақыты /</span><span data-v-d5a430e2>Время</span></div><span class=\"content__value\" data-v-d5a430e2></span></div></div></div>", 1)
const _hoisted_219 = { class: "content__row" }
const _hoisted_220 = {
  class: "content__block",
  style: {"padding":"0","display":"grid"}
}
const _hoisted_221 = { class: "content__block receiver-sign block--border-default" }
const _hoisted_222 = { class: "receiver-sign__columns" }
const _hoisted_223 = /*#__PURE__*/_createVNode("div", { class: "columns__column" }, [
  /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createVNode("span", null, "Жіберуші қолы /"),
    /*#__PURE__*/_createVNode("span", null, "Подпись отправителя")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "content__value" })
], -1)
const _hoisted_224 = { class: "columns__column" }
const _hoisted_225 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", null, "Күні /"),
  /*#__PURE__*/_createVNode("span", null, "Дата")
], -1)
const _hoisted_226 = { class: "content__value" }
const _hoisted_227 = { class: "columns__column" }
const _hoisted_228 = /*#__PURE__*/_createVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createVNode("span", { style: {"white-space":"nowrap"} }, "Уақыты /"),
  /*#__PURE__*/_createVNode("span", null, "Время")
], -1)
const _hoisted_229 = {
  class: "content__value",
  style: {"white-space":"nowrap"}
}
const _hoisted_230 = /*#__PURE__*/_createVNode("p", { class: "receiver-sign__hint" }, " Қолымды қою арқылы офертаның шарттарымен (жүк құжаттың артқы жағынан немесе www.spark.kz сайтында қараңыз) танысқанымды және олармен толық келісетінімді растаймын./ Настоящей подписью подтверждаю, что я ознакомлен(а) и полностью согласен(а) с условиями оферты (см. на обратной стороне накладной или на сайте www.spark.kz) ", -1)
const _hoisted_231 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block courier-sign block--border-default\" data-v-d5a430e2><p class=\"courier-sign__hint\" data-v-d5a430e2> Курьермен толтырылады. Барлық жолдарды толтыру міндетті/ Заполняется Курьером. Все поля обязательны к заполнению </p><div class=\"courier-sign__columns\" data-v-d5a430e2><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Алушы курьер /</span><span data-v-d5a430e2>Курьер забора</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Күні /</span><span data-v-d5a430e2>Дата</span></div><span class=\"content__value\" data-v-d5a430e2></span></div><div class=\"columns__column\" data-v-d5a430e2><div class=\"content__label\" data-v-d5a430e2><span data-v-d5a430e2>Уақыты /</span><span data-v-d5a430e2>Время</span></div><span class=\"content__value\" data-v-d5a430e2></span></div></div></div>", 1)
const _hoisted_232 = {
  class: "content__block end",
  style: {"padding":"0","margin-top":"4px"}
}
const _hoisted_233 = { class: "content__block qr block--border-full" }
const _hoisted_234 = /*#__PURE__*/_createVNode("div", {
  class: "content__label",
  style: {"font-size":"6px"}
}, [
  /*#__PURE__*/_createVNode("span", null, "Көпшілік офертасы /"),
  /*#__PURE__*/_createVNode("span", null, "Публичная оферта")
], -1)
const _hoisted_235 = /*#__PURE__*/_createVNode("div", {
  class: "content__label",
  style: {"font-size":"6px"}
}, [
  /*#__PURE__*/_createVNode("span", null, "Орауға қойылатын талаптар /"),
  /*#__PURE__*/_createVNode("span", null, "Требования к упаковке")
], -1)
const _hoisted_236 = /*#__PURE__*/_createVNode("div", { class: "end__contacts" }, [
  /*#__PURE__*/_createVNode("p", null, "Контакты:"),
  /*#__PURE__*/_createVNode("p", null, "+7 707 345 44 45"),
  /*#__PURE__*/_createVNode("p", null, "+7 747 094 18 30"),
  /*#__PURE__*/_createVNode("p", null, "mail@spark.kz"),
  /*#__PURE__*/_createVNode("p", null, "Spark.kz")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_invoice_document_checkbox = _resolveComponent("invoice-document-checkbox")!
  const _component_invoice_document_header = _resolveComponent("invoice-document-header")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[0]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_9, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[1]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_10, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[2]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[0]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_15, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[1]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_16, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[2]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("img", {
            id: 'barcode_' + _ctx.invoice.invoice_number,
            class: "barcode",
            "data-value": _ctx.invoice.invoice_number,
            src: `data:image/png;base64, ${_ctx.invoice.barcode_html}`,
            "data-format": "CODE39",
            "data-fontSize": "32px"
          }, null, 8, ["id", "data-value", "src"])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.invoice.invoice_number), 1),
          _hoisted_21
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("span", _hoisted_25, [
            (_ctx.invoice.order_number)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.order_number), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_26
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("span", _hoisted_29, [
            (_ctx.invoice.dop_invoice_number)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.dop_invoice_number), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_30
                ], 64))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.shipment_type_id === 1
            }, null, 8, ["checked"]),
            _hoisted_34
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: Boolean(_ctx.invoice.is_dangerous)
            }, null, 8, ["checked"]),
            _hoisted_36
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.shipment_type_id === 2
            }, null, 8, ["checked"]),
            _hoisted_38
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: Boolean(_ctx.invoice.temperature_regime)
            }, null, 8, ["checked"]),
            _hoisted_40
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_invoice_document_checkbox, { checked: false }),
            _hoisted_42
          ]),
          _createVNode("div", _hoisted_43, _toDisplayString(_ctx.invoice.temperature_regime ? _ctx.invoice.temperature_regime.title : ''), 1),
          _createVNode("div", _hoisted_44, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.has_battery
            }, null, 8, ["checked"]),
            _hoisted_45
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.has_auto_parts
            }, null, 8, ["checked"]),
            _hoisted_47
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode("div", _hoisted_49, [
        _createVNode(_component_invoice_document_header, {
          number: 1,
          title: "Жіберушінің ақпараттары / ДАННЫЕ ОТПРАВИТЕЛЯ"
        }),
        _createVNode(_component_invoice_document_header, {
          number: 4,
          title: "Алушының ақпараттары / ДАННЫЕ ПОЛУЧАТЕЛЯ"
        })
      ]),
      _createVNode("div", _hoisted_50, [
        _createVNode("div", _hoisted_51, [
          _hoisted_52,
          _createVNode("span", _hoisted_53, [
            (_ctx.invoice.sender.title)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.sender.title), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_54
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_55, [
          _hoisted_56,
          _createVNode("span", _hoisted_57, [
            (_ctx.invoice.receiver.title)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.title), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_58
                ], 64))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_59, [
        _createVNode("div", _hoisted_60, [
          _createVNode("div", _hoisted_61, [
            _hoisted_62,
            _createVNode("span", _hoisted_63, [
              (_ctx.invoice.sender.full_address)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.full_address), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_64
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode("span", _hoisted_67, [
              (_ctx.invoice.sender.sectorName)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.sectorName), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_68
                  ], 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_69, [
          _createVNode("div", _hoisted_70, [
            _hoisted_71,
            _createVNode("span", _hoisted_72, [
              (_ctx.invoice.receiver.full_address)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_address), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_73
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_74, [
            _hoisted_75,
            _createVNode("span", _hoisted_76, [
              (_ctx.invoice.receiver.sectorName)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.sectorName), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_77
                  ], 64))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_78, [
        _createVNode("div", _hoisted_79, [
          _createVNode("div", _hoisted_80, [
            _hoisted_81,
            _createVNode("span", _hoisted_82, [
              (_ctx.invoice.sender.house)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.house), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_83
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_84, [
            _hoisted_85,
            _createVNode("span", _hoisted_86, [
              (_ctx.invoice.sender.office)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.office), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_87
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_88, [
            _hoisted_89,
            _createVNode("span", _hoisted_90, [
              (_ctx.invoice.sender.index)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.index), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_91
                  ], 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_92, [
          _createVNode("div", _hoisted_93, [
            _hoisted_94,
            _createVNode("span", _hoisted_95, [
              (_ctx.invoice.receiver.house)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.house), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_96
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_97, [
            _hoisted_98,
            _createVNode("span", _hoisted_99, [
              (_ctx.invoice.receiver.office)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.office), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_100
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_101, [
            _hoisted_102,
            _createVNode("span", _hoisted_103, [
              (_ctx.invoice.receiver.index)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.index), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_104
                  ], 64))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _hoisted_107,
          _createVNode("span", _hoisted_108, [
            (_ctx.invoice.sender.comment)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.sender.comment), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_109
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_110, [
          _hoisted_111,
          _createVNode("span", _hoisted_112, [
            (_ctx.invoice.receiver.comment)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.comment), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_113
                ], 64))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_114, [
        _createVNode("div", _hoisted_115, [
          _createVNode("div", _hoisted_116, [
            _hoisted_117,
            _createVNode("span", _hoisted_118, [
              (_ctx.invoice.sender.phone && _ctx.invoice.sender.additional_phone)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone) + ", " + _toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                  ], 64))
                : (_ctx.invoice.sender.phone && !_ctx.invoice.sender.additional_phone)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone), 1)
                    ], 64))
                  : (!_ctx.invoice.sender.phone && _ctx.invoice.sender.additional_phone)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _hoisted_119
                      ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_120, [
            _hoisted_121,
            _createVNode("span", _hoisted_122, [
              (_ctx.invoice.sender.full_name)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.full_name), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_123
                  ], 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_124, [
          _createVNode("div", _hoisted_125, [
            _hoisted_126,
            _createVNode("span", _hoisted_127, [
              (_ctx.invoice.receiver.phone && _ctx.invoice.receiver.additional_phone)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone) + ", " + _toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                  ], 64))
                : (
                                    _ctx.invoice.receiver.phone && !_ctx.invoice.receiver.additional_phone
                                )
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone), 1)
                    ], 64))
                  : (
                                    !_ctx.invoice.receiver.phone && _ctx.invoice.receiver.additional_phone
                                )
                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _hoisted_128
                      ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_129, [
            _hoisted_130,
            _createVNode("span", _hoisted_131, [
              (_ctx.invoice.receiver.full_name)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_name), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_132
                  ], 64))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_133, [
        _createVNode(_component_invoice_document_header, {
          number: 2,
          title: "қосымша ақпарат / Дополнительная  информация"
        }),
        _createVNode(_component_invoice_document_header, {
          number: 5,
          title: "қосымша ақпарат / Дополнительная  информация"
        })
      ]),
      _createVNode("div", _hoisted_134, [
        _createVNode("div", _hoisted_135, [
          _createVNode("div", _hoisted_136, [
            _hoisted_137,
            _createVNode("span", _hoisted_138, [
              (_ctx.invoice.places)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.places), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_139
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_140, [
            _hoisted_141,
            _createVNode("span", _hoisted_142, [
              (_ctx.invoice.weight)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.weight), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_143
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_144, [
            _hoisted_145,
            _createVNode("span", _hoisted_146, [
              (_ctx.invoice.volume)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.volume), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_147
                  ], 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_148, [
          _createVNode("div", _hoisted_149, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('loader')
            }, null, 8, ["checked"]),
            _hoisted_150
          ]),
          _createVNode("div", _hoisted_151, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('hydraulic_trolley')
            }, null, 8, ["checked"]),
            _hoisted_152
          ]),
          _createVNode("div", _hoisted_153, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('crane')
            }, null, 8, ["checked"]),
            _hoisted_154
          ])
        ])
      ]),
      _createVNode("div", _hoisted_155, [
        _createVNode("div", _hoisted_156, [
          _createVNode("div", _hoisted_157, [
            _hoisted_158,
            _createVNode("span", _hoisted_159, [
              (_ctx.invoice.cash_sum)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.cash_sum), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_160
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_161, [
            _hoisted_162,
            _createVNode("span", _hoisted_163, [
              (_ctx.invoice.cod_payment)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.cod_payment), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_164
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_165, [
            _hoisted_166,
            _createVNode("span", _hoisted_167, [
              (_ctx.invoice.declared_price)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.declared_price), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_168
                  ], 64))
            ])
          ])
        ]),
        _createVNode(_component_invoice_document_header, {
          number: 6,
          title: "АЛУШЫ / ПОЛУЧАТЕЛЬ"
        })
      ]),
      _createVNode("div", _hoisted_169, [
        _createVNode("div", _hoisted_170, [
          (_ctx.invoice.payment_type_id === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_171, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 1
                }, null, 8, ["checked"]),
                _hoisted_172
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_type_id === 3)
            ? (_openBlock(), _createBlock("div", _hoisted_173, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 3
                }, null, 8, ["checked"]),
                _hoisted_174
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_method_id === 2)
            ? (_openBlock(), _createBlock("div", _hoisted_175, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_method_id === 2
                }, null, 8, ["checked"]),
                _hoisted_176
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_type_id === 2)
            ? (_openBlock(), _createBlock("div", _hoisted_177, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 2
                }, null, 8, ["checked"]),
                _hoisted_178
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_method_id === 4)
            ? (_openBlock(), _createBlock("div", _hoisted_179, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_method_id === 4
                }, null, 8, ["checked"]),
                _hoisted_180
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_181, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.payment_method_id === 3
            }, null, 8, ["checked"]),
            _hoisted_182
          ])
        ]),
        _createVNode("div", _hoisted_183, [
          _hoisted_184,
          _createVNode("span", _hoisted_185, [
            (_ctx.invoice.receiver.full_name)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_name), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_186
                ], 64))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_187, [
        _createVNode("div", _hoisted_188, [
          _hoisted_189,
          _createVNode("span", _hoisted_190, _toDisplayString(_ctx.invoice.product_name), 1)
        ]),
        _hoisted_191
      ]),
      _createVNode("div", _hoisted_192, [
        _createVNode("div", _hoisted_193, [
          _createVNode("div", _hoisted_194, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('loader')
            }, null, 8, ["checked"]),
            _hoisted_195
          ]),
          _createVNode("div", _hoisted_196, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('hydraulic_trolley')
            }, null, 8, ["checked"]),
            _hoisted_197
          ]),
          _createVNode("div", _hoisted_198, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('crane')
            }, null, 8, ["checked"]),
            _hoisted_199
          ])
        ]),
        _hoisted_200
      ]),
      _createVNode("div", _hoisted_201, [
        _createVNode("div", _hoisted_202, [
          _createVNode("div", _hoisted_203, [
            _createVNode("div", _hoisted_204, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('grid')
              }, null, 8, ["checked"]),
              _hoisted_205
            ]),
            _createVNode("div", _hoisted_206, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('soft_package')
              }, null, 8, ["checked"]),
              _hoisted_207
            ]),
            _createVNode("div", _hoisted_208, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('pallet')
              }, null, 8, ["checked"]),
              _hoisted_209
            ])
          ]),
          _createVNode(_component_invoice_document_header, {
            number: 3,
            title: "Жіберуші / ОТПРАВИТЕЛЬ"
          })
        ]),
        _hoisted_210
      ]),
      _createVNode("div", _hoisted_211, [
        _createVNode("div", _hoisted_212, [
          _createVNode("div", _hoisted_213, [
            _hoisted_214,
            _createVNode("span", _hoisted_215, [
              (_ctx.invoice.annotation)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.annotation), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_216
                  ], 64))
            ])
          ]),
          _hoisted_217
        ]),
        _hoisted_218
      ]),
      _createVNode("div", _hoisted_219, [
        _createVNode("div", _hoisted_220, [
          _createVNode("div", _hoisted_221, [
            _createVNode("div", _hoisted_222, [
              _hoisted_223,
              _createVNode("div", _hoisted_224, [
                _hoisted_225,
                _createVNode("span", _hoisted_226, _toDisplayString(_ctx.invoice.take_date), 1)
              ]),
              _createVNode("div", _hoisted_227, [
                _hoisted_228,
                _createVNode("span", _hoisted_229, _toDisplayString(_ctx.invoice.period), 1)
              ])
            ]),
            _hoisted_230
          ]),
          _hoisted_231
        ]),
        _createVNode("div", _hoisted_232, [
          _createVNode("div", _hoisted_233, [
            _hoisted_234,
            _createVNode(_component_vue_qrcode, {
              value: _ctx.PUBLIC_OFFER_LINK,
              options: { width: 70 }
            }, null, 8, ["value"]),
            _hoisted_235,
            _createVNode(_component_vue_qrcode, {
              value: _ctx.PACKING_REQUIREMENTS_LINK,
              options: { width: 70 }
            }, null, 8, ["value"])
          ]),
          _hoisted_236
        ])
      ])
    ])
  ]))
})